module.exports = __webpack_public_path__ + "media/images/lp_cv-block-2-77e7d241fe48b28c9187b314483bacc5.webp";